import HorseStyled from './styled'

function Horse() {
  return <HorseStyled>horse styled page</HorseStyled>
}

export default Horse
